// document.addEventListener("DOMContentLoaded", function () {
//     console.log("🚀 Script Loaded: Waiting for elements...");

//     function initializeVariantImageSwitcher() {
//         console.log("✅ Initializing Variant Image Switcher...");

//         const variantOptionsContainer = document.querySelector("ul.avis-option-values");
//         const mediaWrapper = document.querySelector(".product__media-wrapper");
//         const mediaModalContent = document.querySelector(".variant-meta-media-modal__content");

//         if (!variantOptionsContainer || !mediaWrapper || !mediaModalContent) {
//             console.log("🛑 ERROR: One or more elements not found. Retrying...");
//             return;
//         }

//         const mediaObserver = new MutationObserver(() => {
//             console.log("🧐 Detected media content change. Checking for updates...");
//             setTimeout(() => {
//                 const updatedValue = getSelectedVariantValue();
//                 if (updatedValue) {
//                     updateImages(updatedValue);
//                 }
//             }, 10);
//         });

//         function observeMediaChanges() {
//             mediaObserver.disconnect(); // **Fix: Ensure we don't create duplicate observers**
//             mediaObserver.observe(mediaWrapper, { childList: true, subtree: true });
//             mediaObserver.observe(mediaModalContent, { childList: true, subtree: true });
//             console.log("🔄 Observer reattached for media changes.");
//         }

//         function updateImages(selectedValue) {
//             if (!selectedValue) {
//                 console.log("❌ No selected variant found. Skipping image update.");
//                 return;
//             }

//             console.log(`🎯 Updating images for variant: ${selectedValue}`);
            
//             mediaObserver.disconnect(); // **Fix: Temporarily stop observing during update**

//             let subMediaItems = [];
//             let mainMediaItems = [];
//             let modalImages = [];

//             // **Handle Sub Media Items**
//             document.querySelectorAll(".product__media-subitem.variant-meta_media").forEach(mediaItem => {
//                 const mediaImage = mediaItem.querySelector("img");
//                 if (mediaImage) {
//                     const imageValue = mediaImage.getAttribute("data-value")?.trim().toLowerCase();
//                     const isVisible = imageValue === selectedValue;

//                     mediaItem.style.display = isVisible ? "block" : "none";
//                     subMediaItems.push({ element: mediaItem, isVisible });
//                 }
//             });

//             // **Handle Main Media Items**
//             document.querySelectorAll(".product__media-item.main_variant-meta_media").forEach(mediaItem => {
//                 const mediaImage = mediaItem.querySelector("img");
//                 if (mediaImage) {
//                     const imageValue = mediaImage.getAttribute("data-value")?.trim().toLowerCase();
//                     const isVisible = imageValue === selectedValue;

//                     mediaItem.style.display = isVisible ? "block" : "none";
//                     mainMediaItems.push({ element: mediaItem, isVisible });
//                 }
//             });

//             // **Handle Modal Images**
//             document.querySelectorAll(".variant-meta-media-modal__content img.motion-reduce").forEach(mediaImage => {
//                 const imageValue = mediaImage.getAttribute("data-value")?.trim().toLowerCase();
//                 const isVisible = imageValue === selectedValue;

//                 mediaImage.style.display = isVisible ? "block" : "none";
//                 modalImages.push({ element: mediaImage, isVisible });
//             });

//             // **Reorder Elements (Visible First, Hidden Last)**
//             function reorderElements(container, items) {
//                 items.sort((a, b) => b.isVisible - a.isVisible);
//                 items.forEach(item => container.appendChild(item.element));
//             }

//             const subMediaContainer = document.querySelector(".product__media-subitem.variant-meta_media")?.parentElement;
//             const mainMediaContainer = document.querySelector(".product__media-item.main_variant-meta_media")?.parentElement;
//             const modalContainer = document.querySelector(".variant-meta-media-modal__content");

//             if (subMediaContainer) reorderElements(subMediaContainer, subMediaItems);
//             if (mainMediaContainer) reorderElements(mainMediaContainer, mainMediaItems);
//             if (modalContainer) reorderElements(modalContainer, modalImages);

//             console.log("✅ Image visibility and order updated for main, sub, and modal images.");

//             observeMediaChanges(); // **Fix: Restart observer after updates**
//         }

//         function getSelectedVariantValue() {
//             const checkedInput = variantOptionsContainer.querySelector("input[type='radio']:checked");
//             if (checkedInput) {
//                 let valueElement = checkedInput.closest(".avis-option-value-item");
//                 if (valueElement) {
//                     let value = valueElement.dataset.value?.trim().toLowerCase();
//                     console.log(`📌 Selected Variant: ${value}`);
//                     return value;
//                 }
//             }
//             console.log("⚠️ No selected variant found.");
//             return null;
//         }

//         // Set initial images
//         const defaultValue = getSelectedVariantValue();
//         if (defaultValue) {
//             updateImages(defaultValue);
//         }

//         // Listen for variant change
//         variantOptionsContainer.addEventListener("change", function (event) {
//             if (event.target.matches("input[type='radio']")) {
//                 setTimeout(() => {
//                     const selectedValue = getSelectedVariantValue();
//                     if (selectedValue) {
//                         console.log(`🔄 Variant changed: ${selectedValue}`);
//                         updateImages(selectedValue);
//                     }
//                 }, 10);
//             }
//         });

//         observeMediaChanges(); // **Fix: Start observing immediately**

//         console.log("✅ Variant Image Switcher Fully Initialized.");
//     }

//     function waitForElement(selector, callback) {
//         const checkExist = setInterval(() => {
//             const element = document.querySelector(selector);
//             if (element) {
//                 clearInterval(checkExist);
//                 console.log(`🔍 Found element: ${selector}`);
//                 callback();
//             }
//         }, 100);
//     }

//     waitForElement(".product__media-wrapper", initializeVariantImageSwitcher);
// });


// document.addEventListener("DOMContentLoaded", function () {
//     console.log("🚀 Script Loaded: Waiting for elements...");

//     function initializeVariantImageSwitcher() {
//         console.log("✅ Initializing Variant Image Switcher...");

//         const variantOptionsContainer = document.querySelector("ul.avis-option-values");
//         const mediaWrapper = document.querySelector(".product__media-wrapper");
//         const mediaModalContent = document.querySelector(".variant-meta-media-modal__content");

//         if (!variantOptionsContainer || !mediaWrapper || !mediaModalContent) {
//             console.log("🛑 ERROR: One or more elements not found. Retrying...");
//             return;
//         }

//         const mediaObserver = new MutationObserver(() => {
//             console.log("🧐 Detected media content change. Checking for updates...");
//             setTimeout(() => {
//                 const updatedValue = getSelectedVariantValue();
//                 if (updatedValue) {
//                     updateImages(updatedValue);
//                 }
//             }, 100);
//         });

//         function observeMediaChanges() {
//             mediaObserver.disconnect();
//             mediaObserver.observe(mediaWrapper, { childList: true, subtree: true });
//             mediaObserver.observe(mediaModalContent, { childList: true, subtree: true });
//             console.log("🔄 Observer reattached for media changes.");
//         }

//         function updateImages(selectedValue) {
//             if (!selectedValue) {
//                 console.log("❌ No selected variant found. Skipping image update.");
//                 return;
//             }

//             console.log(`🎯 Updating images for variant: ${selectedValue}`);
            
//             mediaObserver.disconnect();

//             let subMediaItems = [];
//             let mainMediaItems = [];
//             let modalImages = [];

//             document.querySelectorAll(".product__media-subitem.variant-meta_media").forEach(mediaItem => {
//                 const mediaImage = mediaItem.querySelector("img");
//                 if (mediaImage) {
//                     const imageValue = mediaImage.getAttribute("data-value")?.trim().toLowerCase();
//                     const isVisible = imageValue === selectedValue;

//                     mediaItem.style.display = isVisible ? "block" : "none";
//                     subMediaItems.push({ element: mediaItem, isVisible });
//                 }
//             });

//             document.querySelectorAll(".product__media-item.main_variant-meta_media").forEach(mediaItem => {
//                 const mediaImage = mediaItem.querySelector("img");
//                 if (mediaImage) {
//                     const imageValue = mediaImage.getAttribute("data-value")?.trim().toLowerCase();
//                     const isVisible = imageValue === selectedValue;

//                     mediaItem.style.display = isVisible ? "block" : "none";
//                     mainMediaItems.push({ element: mediaItem, isVisible });
//                 }
//             });

//             document.querySelectorAll(".variant-meta-media-modal__content img.motion-reduce").forEach(mediaImage => {
//                 const imageValue = mediaImage.getAttribute("data-value")?.trim().toLowerCase();
//                 const isVisible = imageValue === selectedValue;

//                 mediaImage.style.display = isVisible ? "block" : "none";
//                 modalImages.push({ element: mediaImage, isVisible });
//             });

//             function reorderElements(container, items) {
//                 items.sort((a, b) => b.isVisible - a.isVisible);
//                 items.forEach(item => container.appendChild(item.element));
//             }

//             const subMediaContainer = document.querySelector(".product__media-subitem.variant-meta_media")?.parentElement;
//             const mainMediaContainer = document.querySelector(".product__media-item.main_variant-meta_media")?.parentElement;
//             const modalContainer = document.querySelector(".variant-meta-media-modal__content");

//             if (subMediaContainer) reorderElements(subMediaContainer, subMediaItems);
//             if (mainMediaContainer) reorderElements(mainMediaContainer, mainMediaItems);
//             if (modalContainer) reorderElements(modalContainer, modalImages);

//             console.log("✅ Image visibility and order updated for main, sub, and modal images.");

//             observeMediaChanges();
//         }

//         function getSelectedVariantValue() {
//             let selectedValues = [];
            
//             document.querySelectorAll(".avis-swatch-option").forEach(option => {
//                 let checkedInput = option.querySelector("input[type='radio']:checked");
//                 if (checkedInput) {
//                     let valueElement = checkedInput.closest(".avis-option-value-item");
//                     if (valueElement) {
//                         let value = valueElement.dataset.value?.trim().toLowerCase();
//                         selectedValues.push(value);
//                     }
//                 }
//             });
            
//             let combinedValue = selectedValues.join(" / ");
//             console.log(`📌 Combined Selected Variant: ${combinedValue}`);
//             return combinedValue;
//         }

//         const defaultValue = getSelectedVariantValue();
//         if (defaultValue) {
//             updateImages(defaultValue);
//         }

//         variantOptionsContainer.addEventListener("change", function (event) {
//             if (event.target.matches("input[type='radio']")) {
//                 setTimeout(() => {
//                     const selectedValue = getSelectedVariantValue();
//                     if (selectedValue) {
//                         console.log(`🔄 Variant changed: ${selectedValue}`);
//                         updateImages(selectedValue);
//                     }
//                 }, 100);
//             }
//         });

//         observeMediaChanges();

//         console.log("✅ Variant Image Switcher Fully Initialized.");
//     }

//     function waitForElement(selector, callback) {
//         const checkExist = setInterval(() => {
//             const element = document.querySelector(selector);
//             if (element) {
//                 clearInterval(checkExist);
//                 console.log(`🔍 Found element: ${selector}`);
//                 callback();
//             }
//         }, 500);
//     }

//     waitForElement(".product__media-wrapper", initializeVariantImageSwitcher);
// });






// document.addEventListener("DOMContentLoaded", function () {
//     const button = document.querySelector(".product__media-sublist .swiper-btn.swiper-btn-next");

//     function getLastVisibleElement() {
//         const container = document.querySelector(".product__media-sublist .swiper-wrapper");
//         if (!container) return null;

//         // Get all children and filter only those with display: block
//         const items = Array.from(container.children).filter(el => getComputedStyle(el).display === "block");

//         return items.length ? items[items.length - 1] : null;
//     }

//     function isElementInViewport(el) {
//         const rect = el.getBoundingClientRect();
//         return rect.top >= 0 && rect.bottom <= window.innerHeight;
//     }

//     function checkVisibility() {
//         const lastVisibleItem = getLastVisibleElement();
//         console.log(isElementInViewport(lastVisibleItem))
//         if (lastVisibleItem && isElementInViewport(lastVisibleItem)) {
//             button.classList.add("swiper-button-disabled"); // Disable button if item is visible
//         } else {
//             button.classList.remove("swiper-button-disabled"); // Enable button if item is not fully visible
//         }
//     }

//     // Run check when button is clicked
//     button.addEventListener("click", checkVisibility);
// });

// $(document).on("input", ".range-slider input", function(){
// var get = $(this).val();
//     var min = $("input.range-value.min-value").val(get);
// });
// $(document).on("change", ".range-slider input", function(e){
//     e.stopPropagation();
//     e.preventDefault();
//     var get = $(this).val();
//     var min = $("input.range-value.min-value").val(get);
//     var max = $("input.range-value.max-value").val();
//      console.log(get);
//      console.log(max);
//     // const filteredItems = $("li").filter(function () {
//     //     const val = parseFloat($(this).text());
//     //     return val >= min && val <= max;
//     // });
//   $("input.focus-inset[value='"+get+"']").addClass("here-it-is");
//     $("input.focus-inset[value='"+get+"']").trigger("click");
//      $("input.focus-inset[value='"+get+"']").trigger("change");
    
//     // filteredItems.each(function () {
//     //   //  console.log($(this).text()); // Log matching values
//     // });
//   })

$(document).ready(function () {
  let arrSelected = [];

  const rangeValues = $(".array-form-values").text();
  const arr = rangeValues.split(",").map(parseFloat);
  console.log("Parsed Carat Array:", arr);

  // Prevent unnecessary trigger loops
  let debounceTimer;
  function debounceFilter(min, max) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      filterArray(min, max);
    }, 300);
  }

  function sanitizeValue(val, min, max) {
    val = parseFloat(val);
    val = Math.max(min, Math.min(val, max));
    return val.toFixed(2);
  }

  function syncAllSliders(minVal, maxVal) {
  const min = minVal.toFixed(2);
  const max = maxVal.toFixed(2);

  // Update input values
  $('#carat-min, #mobile-carat-min').val(min);
  $('#carat-min-input, #mobile-carat-min-input').val(min);
  $('#carat-max, #mobile-carat-max').val(max);
  $('#carat-max-input, #mobile-carat-max-input').val(max);

  // Calculate the percentage values relative to full range
  const minRange = parseFloat($('#carat-min').attr('min'));
  const maxRange = parseFloat($('#carat-max').attr('max'));
  const range = maxRange - minRange;

  const percentMin = ((minVal - minRange) / range) * 100;
  const percentMax = ((maxVal - minRange) / range) * 100;

  // Apply CSS variables
  $('.range-slider').css('--range-min', `${percentMin}%`);
  $('.range-slider').css('--range-max', `${percentMax}%`);
}

  function filterArray(min, max) {
    const filtered = arr.filter(val => val >= min && val <= max);
    console.log("Filtered values within range:", filtered);

    $('.facets__display.facets-main-stone-carat-weight input.focus-inset').each(function () {
      const checkboxVal = parseFloat($(this).val());
      const isInRange = checkboxVal >= min && checkboxVal <= max;

      if (isInRange !== $(this).prop('checked')) {
        $(this).prop('checked', isInRange);
      }
    });
    $('ul.mobile-facets__list.list-unstyled.main-stone-carat-weight input.mobile-facets__checkbox').each(function () {
      const checkboxVal = parseFloat($(this).val());
      const isInRange = checkboxVal >= min && checkboxVal <= max;

      if (isInRange !== $(this).prop('checked')) {
        $(this).prop('checked', isInRange);
      }
    });
    
    
  }

  function getBoundsAndFilter() {
    const minVal = parseFloat($('#carat-min').val());
    const maxVal = parseFloat($('#carat-max').val());
    const mobminVal = parseFloat($('#mobile-carat-min').val());
    const mobmaxVal = parseFloat($('#mobile-carat-max').val());

    debounceFilter(minVal, maxVal);
    debounceFilter(mobminVal, mobmaxVal);
  }

  //on load change the min max values
  $(".active-facets.active-facets-desktop .active-facets__wrapper facet-remove[main-stone-carat-weight]").each(function () {
      const val = parseFloat($(this).find("span").attr("value"));
      if (!isNaN(val)) arrSelected.push(val);
    });

    if (arrSelected.length > 0) {
      const minSelected = Math.min(...arrSelected);
      const maxSelected = Math.max(...arrSelected);

      console.log("Selected Min:", minSelected, "Selected Max:", maxSelected);

      setTimeout(() => {
        syncAllSliders(minSelected, maxSelected);
        filterArray(minSelected, maxSelected);
      }, 3000);
    }

  $(".active-facets.active-facets-mobile facet-remove[main-stone-carat-weight]").each(function () {
      const val = parseFloat($(this).find("span").attr("value"));
      if (!isNaN(val)) arrSelected.push(val);
    });

    if (arrSelected.length > 0) {
      const minSelected = Math.min(...arrSelected);
      const maxSelected = Math.max(...arrSelected);

      console.log("Selected Min:", minSelected, "Selected Max:", maxSelected);

      setTimeout(() => {
        syncAllSliders(minSelected, maxSelected);
        filterArray(minSelected, maxSelected);
      }, 3000);
    }

  
  // Listen for checkbox filter changes
  $(document).on("change", "details.not-main-stone-carat-weight input", function () {
    arrSelected = [];

    $(".active-facets.active-facets-desktop .active-facets__wrapper facet-remove[main-stone-carat-weight]").each(function () {
      const val = parseFloat($(this).find("span").attr("value"));
      if (!isNaN(val)) arrSelected.push(val);
    });

    if (arrSelected.length > 0) {
      const minSelected = Math.min(...arrSelected);
      const maxSelected = Math.max(...arrSelected);

      console.log("Selected Min:", minSelected, "Selected Max:", maxSelected);

      setTimeout(() => {
        syncAllSliders(minSelected, maxSelected);
        filterArray(minSelected, maxSelected);
      }, 4000);
    }
  });

   $(document).on("click", ".mobile-facets__inner button.no-js-hidden.button.button--primary.focus-inset", function () {
    arrSelected = [];

    $(".active-facets.active-facets-mobile facet-remove[main-stone-carat-weight]").each(function () {
      const val = parseFloat($(this).find("span").attr("value"));
      if (!isNaN(val)) arrSelected.push(val);
    });

    if (arrSelected.length > 0) {
      const minSelected = Math.min(...arrSelected);
      const maxSelected = Math.max(...arrSelected);

      console.log("Selected Min:", minSelected, "Selected Max:", maxSelected);

      setTimeout(() => {
        syncAllSliders(minSelected, maxSelected);
        filterArray(minSelected, maxSelected);
      }, 4000);
    }
  });

  // ----------- DESKTOP SLIDER + INPUT EVENTS -----------

  $(document).on('input change', '#carat-min', function () {
    const minVal = parseFloat($(this).val());
    const maxVal = parseFloat($('#carat-max').val());
    const safeMin = minVal >= maxVal ? maxVal - 0.01 : minVal;

    $('#carat-min, #carat-min-input').val(safeMin.toFixed(2));
    syncAllSliders(safeMin, maxVal);
    getBoundsAndFilter();
  });

  $(document).on('input change', '#carat-max', function () {
    const maxVal = parseFloat($(this).val());
    const minVal = parseFloat($('#carat-min').val());
    const safeMax = maxVal <= minVal ? minVal + 0.01 : maxVal;

    $('#carat-max, #carat-max-input').val(safeMax.toFixed(2));
    syncAllSliders(minVal, safeMax);
    getBoundsAndFilter();
  });

  $(document).on('input change', '#carat-min-input', function () {
    const inputVal = parseFloat($(this).val());
    const maxVal = parseFloat($('#carat-max').val());
    const minAttr = parseFloat($('#carat-min').attr('min'));
    const maxAttr = parseFloat($('#carat-min').attr('max'));

    const safeVal = inputVal >= maxVal ? maxVal - 0.01 : inputVal;
    const clamped = sanitizeValue(safeVal, minAttr, maxAttr);

    $('#carat-min-input, #carat-min').val(clamped);
    syncAllSliders(parseFloat(clamped), maxVal);
    getBoundsAndFilter();
  });

  $(document).on('input change', '#carat-max-input', function () {
    const inputVal = parseFloat($(this).val());
    const minVal = parseFloat($('#carat-min').val());
    const minAttr = parseFloat($('#carat-max').attr('min'));
    const maxAttr = parseFloat($('#carat-max').attr('max'));

    const safeVal = inputVal <= minVal ? minVal + 0.01 : inputVal;
    const clamped = sanitizeValue(safeVal, minAttr, maxAttr);

    $('#carat-max-input, #carat-max').val(clamped);
    syncAllSliders(minVal, parseFloat(clamped));
    getBoundsAndFilter();
  });

  // ----------- MOBILE SLIDER + INPUT EVENTS -----------

  $(document).on('input change', '#mobile-carat-min', function () {
    const minVal = parseFloat($(this).val());
    const maxVal = parseFloat($('#mobile-carat-max').val());
    const safeMin = minVal >= maxVal ? maxVal - 0.01 : minVal;

    $('#mobile-carat-min, #mobile-carat-min-input').val(safeMin.toFixed(2));
    syncAllSliders(safeMin, maxVal);
    getBoundsAndFilter();
  });

  $(document).on('input change', '#mobile-carat-max', function () {
    const maxVal = parseFloat($(this).val());
    const minVal = parseFloat($('#mobile-carat-min').val());
    const safeMax = maxVal <= minVal ? minVal + 0.01 : maxVal;

    $('#mobile-carat-max, #mobile-carat-max-input').val(safeMax.toFixed(2));
    syncAllSliders(minVal, safeMax);
    getBoundsAndFilter();
  });

  $(document).on('input change', '#mobile-carat-min-input', function () {
    const inputVal = parseFloat($(this).val());
    const maxVal = parseFloat($('#mobile-carat-max').val());
    const minAttr = parseFloat($('#mobile-carat-min').attr('min'));
    const maxAttr = parseFloat($('#mobile-carat-min').attr('max'));

    const safeVal = inputVal >= maxVal ? maxVal - 0.01 : inputVal;
    const clamped = sanitizeValue(safeVal, minAttr, maxAttr);

    $('#mobile-carat-min-input, #mobile-carat-min').val(clamped);
    syncAllSliders(parseFloat(clamped), maxVal);
    getBoundsAndFilter();
  });

  $(document).on('input change', '#mobile-carat-max-input', function () {
    const inputVal = parseFloat($(this).val());
    const minVal = parseFloat($('#mobile-carat-min').val());
    const minAttr = parseFloat($('#mobile-carat-max').attr('min'));
    const maxAttr = parseFloat($('#mobile-carat-max').attr('max'));

    const safeVal = inputVal <= minVal ? minVal + 0.01 : inputVal;
    const clamped = sanitizeValue(safeVal, minAttr, maxAttr);

    $('#mobile-carat-max-input, #mobile-carat-max').val(clamped);
    syncAllSliders(minVal, parseFloat(clamped));
    getBoundsAndFilter();
  });
});



jQuery(window).on("load", function(){

  var firstSelected = $("input.first-selected").val();
  
  $('.product-media-main').on('init', function() {
    $('#slider-loader').removeClass('active');
  });

 jQuery('.product-media-main').slick({
  slidesToShow: 1,
   lazyLoad: 'ondemand',
  slidesToScroll: 1,
  arrows: true,
  infinite:false,
  dots:false,
  fade: true,
  asNavFor: '.product-media-thumnail',
   prevArrow: '<div class="slick-prev"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.125 13.5L3.75 9M3.75 9L8.125 4.5M3.75 9H14.25" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>',
    nextArrow: '<div class="slick-next"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.875 4.5L14.25 9M14.25 9L9.875 13.5M14.25 9L3.75 9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>'
});
jQuery('.product-media-thumnail').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  lazyLoad: 'ondemand',
  asNavFor: '.product-media-main',
  dots: false,
  infinite:false,
  vertical:true,  
  focusOnSelect: true,
  prevArrow: '<div class="slick-prev"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.125 13.5L3.75 9M3.75 9L8.125 4.5M3.75 9H14.25" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
    nextArrow: '<div class="slick-next"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.875 4.5L14.25 9M14.25 9L9.875 13.5M14.25 9L3.75 9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical:false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical:false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  var options = [];

  $(".avis-swatch-option").each(function(){
      var getValue = $(this).find("ul.avis-option-values input:checked").val();
      console.log(getValue)
      options.push(getValue);
    })
    if($("body").hasClass("body-template-product"))
    {
      $("variant-radios fieldset").each(function(){
        var getValue = $(this).find(".product-form__controls-group input:checked").val();
      // console.log(getValue)
        options.push(getValue);
      });
    }

    if($(".product-card").length != 0)
    {
      $(".product-card .product-form__controls-group input:checked").each(function(){
        const vimg = $(this).attr("data-image-url");
        const vprc = $(this).attr("data-price");
        const vlnk = $(this).attr("data-variant-link");
        if(vimg != "")
        {
          $(this).parents(".product-card").find(".card--product .media--first").attr('src',vimg);
          $(this).parents(".product-card").find(".card--product .media--first").attr('srcset',vimg);
        }
        if(vprc != "")
        {
          $(this).parents(".product-card").find(".price-item").html(vprc);
        }
        $(this).parents(".product-card").find(".product-card-link").attr("href",vlnk);
        
      });
      

      $(document).on("change", ".product-card .product-form__controls-group input", function(){
        const vimage = $(this).attr("data-image-url");
        const vprice = $(this).attr("data-price");
        const vlink = $(this).attr("data-variant-link");
        if(vimage != "")
        {
          $(this).parents(".product-card").find(".card--product .media--first").attr('src',vimage);
          $(this).parents(".product-card").find(".card--product .media--first").attr('srcset',vimage);
        }
        
        if(vprice != "")
        {
          $(this).parents(".product-card").siblings(".price_product-card").find(".price-item").html(vprice);
         // $(this).parents(".template-search__article").find(".price_product-card .price-item").html(vprice);
        }
        $(this).parents(".product-card").find(".product-card-link").attr("href",vlink);
        
      });
    }

    var combinedValue = options.join(" / ");
    console.log(combinedValue+"combinedValue here")
    if ( combinedValue != "" && combinedValue != undefined )
    {
      console.log("it  is in if ")
      $(".product-media-main").slick('slickUnfilter');
    $(".product-media-thumnail").slick('slickUnfilter');
    $(".product-media-main").slick('slickFilter',$(".product__media img[data-value='"+firstSelected+"']").parents(".product__media-item"));
    $(".product-media-thumnail").slick('slickFilter',$(".product__media img[data-value='"+firstSelected+"']").parents(".product__media-subitem"));
    $(".product-media-thumnail").slick('refresh');
    $(".product-media-main").slick('refresh');
   
    
    setTimeout(() => {
    $('.product-media-main .slick-slide').addClass('is-filtered');
       const gallery = lightGallery(document.getElementById('product-lightbox-gallery'), {
                selector: '.is-filtered .gallery-item',
                plugins: [lgZoom, lgVideo, lgThumbnail],
                thumbnail: true,
                // Disable zoom animation
                zoomFromOrigin: false,
                showAfterLoad: true,
                // Preload images to prevent stretching
                preload: 1,
                download: false,
                licenseKey: '0000-0000-000-0000',
                
                // Additional fixes for smooth loading
                onAfterOpen: function() {
    const container = document.querySelector('.lg-outer');
    if (container) {
        container.style.display = 'none';
        container.offsetHeight;
        container.style.display = 'block';
    }

    // Safari Fix: Prevent slide on video click
    const videos = document.querySelectorAll('.lg-video-object video');
    videos.forEach(video => {
        video.addEventListener('click', e => {
            e.stopPropagation();
        });
    });
},
                
                // Pause videos when changing slides
                onBeforeSlide: function() {
                    const videos = document.querySelectorAll('.lg-video-object video');
                    videos.forEach(video => {
                        try {
                            video.pause();
                            video.currentTime = 0;
                        } catch(e) {
                            console.warn('Could not pause video:', e);
                        }
                    });
                }
            });
  }, 100); //
   }
  else
    {
       console.log("it  is in else ")
      // const gallery = lightGallery(document.getElementById('product-lightbox-gallery'), {
      //           selector: '.gallery-item',
      //           plugins: [lgZoom, lgVideo, lgThumbnail],
      //           thumbnail: true,
      //           // Disable zoom animation
      //           zoomFromOrigin: false,
      //           showAfterLoad: true,
      //           // Preload images to prevent stretching
      //           preload: 1,
      //           download: false,
      //           licenseKey: '0000-0000-000-0000',
                
      //           // Additional fixes for smooth loading
      //           onAfterOpen: function() {
      //             const container = document.querySelector('.lg-outer');
      //             if (container) {
      //                 container.style.display = 'none';
      //                 container.offsetHeight;
      //                 container.style.display = 'block';
      //             }

      //             // Safari Fix: Prevent slide on video click
      //             const videos = document.querySelectorAll('.lg-video-object video');
      //             videos.forEach(video => {
      //                 video.addEventListener('click', e => {
      //                     e.stopPropagation();
      //                 });
      //             });
      //         },
                
      //           // Pause videos when changing slides
      //           onBeforeSlide: function() {
      //               const videos = document.querySelectorAll('.lg-video-object video');
      //               videos.forEach(video => {
      //                   try {
      //                       video.pause();
      //                       video.currentTime = 0;
      //                   } catch(e) {
      //                       console.warn('Could not pause video:', e);
      //                   }
      //               });
      //           }
      //       });



const gallery = lightGallery(document.getElementById('product-lightbox-gallery'), {
    selector: '.gallery-item',
    plugins: [lgZoom, lgVideo, lgThumbnail],
    thumbnail: true,
    zoomFromOrigin: false,
    showAfterLoad: true,
    preload: 1,
    download: false,
    licenseKey: '0000-0000-000-0000',

 // force toolbar on mobile
    mobileSettings: {
        controls: true,          // enable prev/next
        showCloseIcon: true,     // enable close button
        counter: true,           // show "1/4"
        download: false          // keep disabled if you want
    },
    // Additional fixes for smooth loading
    onAfterOpen: function() {
        const container = document.querySelector('.lg-outer');
        if (container) {
            container.style.display = 'none';
            container.offsetHeight;
            container.style.display = 'block';
        }

        // Safari Fix: Prevent slide on video click
        const videos = document.querySelectorAll('.lg-video-object video');
        console.log("lightGallery videos found:", videos.length);

        videos.forEach((video, index) => {
            console.log("lightGallery video", index, video);

            video.addEventListener('click', e => e.stopPropagation());

            // Mobile autoplay
            const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
            console.log("Is Mobile?", isMobile);
            if (isMobile) {
                try {
                    video.muted = true;
                    video.setAttribute('playsinline', '');
                    video.setAttribute('autoplay', '');
                    video.setAttribute('loop', '');
                    video.play().then(() => {
                        console.log("lightGallery video autoplay success ✅", video);
                    }).catch(err => {
                        console.warn("lightGallery autoplay blocked ❌", video, err);
                    });
                } catch(e) {
                    console.warn('Could not autoplay lightGallery video:', e);
                }
            }
        });
    },

    onBeforeSlide: function() {
        const videos = document.querySelectorAll('.lg-video-object video');
        console.log("Pausing lightGallery videos on slide change:", videos.length);
        videos.forEach(video => {
            try {
                video.pause();
                video.currentTime = 0;
            } catch(e) {
                console.warn('Could not pause lightGallery video:', e);
            }
        });
    }
});

// -----------------------------
// Slick slider mobile autoplay
function autoplayMobileVideo() {
    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    console.log("Slick slider - Is Mobile?", isMobile);
    if (!isMobile) return;

    const videos = document.querySelectorAll('.product__media-item video');
    console.log("Slick videos found:", videos.length);
    videos.forEach((video, index) => {
        try {
            console.log("Pausing Slick video", index, video);
            video.pause();
            video.currentTime = 0;
        } catch(e) {
            console.warn('Could not pause Slick video:', e);
        }
    });

    const activeVideo = document.querySelector('.product__media-item.slick-current.slick-active video');
    console.log("Slick active video found:", activeVideo);
    if (activeVideo) {
        try {
            activeVideo.muted = true;
            activeVideo.setAttribute('playsinline', '');
            activeVideo.setAttribute('autoplay', '');
            activeVideo.setAttribute('loop', '');
            activeVideo.play().then(() => {
                console.log("Slick active video autoplay success ✅", activeVideo);
            }).catch(err => {
                console.warn("Slick active video autoplay blocked ❌", activeVideo, err);
            });
        } catch(e) {
            console.warn('Could not autoplay Slick video:', e);
        }
    }
}

// Run on page load
autoplayMobileVideo();

// Run autoplay on every slide change for main gallery
$('.product-gallery__main').on('afterChange', function() {
    autoplayMobileVideo();
});

// Run autoplay on every slide change for thumbnail slider
$('.product-media-thumnail').on('afterChange', function() {
    autoplayMobileVideo();
});








    }
  $(document).on("change", ".avis-option-value-item input", function(){
    options = [];
    console.log("chnage")
    $(".product__info-wrapper .avis-swatch-option").each(function(){
      var getValue = $(this).find("ul.avis-option-values input:checked").val();
      console.log(getValue)
      options.push(getValue);
    })
    var combinedValue = options.join(" / ");
    console.log(combinedValue)
    $(".product-media-main").slick('slickUnfilter');
    $(".product-media-thumnail").slick('slickUnfilter');
    $(".product-media-main").slick('slickFilter',$(".product__media img[data-value='"+combinedValue+"']").parents(".product__media-item"));
    $(".product-media-thumnail").slick('slickFilter',$(".product__media img[data-value='"+combinedValue+"']").parents(".product__media-subitem"));
    $(".product-media-thumnail").slick('refresh');
    $(".product-media-main").slick('refresh');
    setTimeout(() => {
    
    $('.product-media-main .slick-slide').addClass('is-filtered');
       const gallery = lightGallery(document.getElementById('product-lightbox-gallery'), {
                selector: '.is-filtered .gallery-item',
                plugins: [lgZoom, lgVideo, lgThumbnail],
                thumbnail: true,
                // Disable zoom animation
                zoomFromOrigin: false,
                showAfterLoad: true,
                // Preload images to prevent stretching
                preload: 1,
                download: false,
                licenseKey: '0000-0000-000-0000',
                
                // Additional fixes for smooth loading
                onAfterOpen: function() {
                    // Force redraw to fix any rendering issues
                    const container = document.querySelector('.lg-outer');
                    if (container) {
                        container.style.display = 'none';
                        container.offsetHeight; // Trigger reflow
                        container.style.display = 'block';
                    }
                },
                
                // Pause videos when changing slides
                onBeforeSlide: function() {
                    const videos = document.querySelectorAll('.lg-video-object video');
                    videos.forEach(video => {
                        try {
                            video.pause();
                            video.currentTime = 0;
                        } catch(e) {
                            console.warn('Could not pause video:', e);
                        }
                    });
                }
            });
  }, 100); //
  })

if($("body").hasClass("body-template-product"))
{

  $(document).on("change", "variant-radios fieldset .product-form__controls-group input", function(){
    options = [];
    //console.log("chnage")
    $(".product__info-wrapper variant-radios fieldset").each(function(){
      var getValue = $(this).find(".product-form__controls-group input:checked").val();
     // console.log(getValue)
      options.push(getValue);
    })
    var combinedValue = options.join(" / ");
    console.log(combinedValue)
    $(".product-media-main").slick('slickUnfilter');
    $(".product-media-thumnail").slick('slickUnfilter');
    $(".product-media-main").slick('slickFilter',$(".product__media img[data-value='"+combinedValue+"']").parents(".product__media-item"));
    $(".product-media-thumnail").slick('slickFilter',$(".product__media img[data-value='"+combinedValue+"']").parents(".product__media-subitem"));
    $(".product-media-thumnail").slick('refresh');
    $(".product-media-main").slick('refresh');
    setTimeout(() => {
    
    $('.product-media-main .slick-slide').addClass('is-filtered');
       const gallery = lightGallery(document.getElementById('product-lightbox-gallery'), {
                selector: '.is-filtered .gallery-item',
                plugins: [lgZoom, lgVideo, lgThumbnail],
                thumbnail: true,
                // Disable zoom animation
                zoomFromOrigin: false,
                showAfterLoad: true,
                // Preload images to prevent stretching
                preload: 1,
                download: false,
                licenseKey: '0000-0000-000-0000',
                
                // Additional fixes for smooth loading
                onAfterOpen: function() {
                    // Force redraw to fix any rendering issues
                    const container = document.querySelector('.lg-outer');
                    if (container) {
                        container.style.display = 'none';
                        container.offsetHeight; // Trigger reflow
                        container.style.display = 'block';
                    }
                },
                
                // Pause videos when changing slides
                onBeforeSlide: function() {
                    const videos = document.querySelectorAll('.lg-video-object video');
                    videos.forEach(video => {
                        try {
                            video.pause();
                            video.currentTime = 0;
                        } catch(e) {
                            console.warn('Could not pause video:', e);
                        }
                    });
                }
            });
  }, 100); //
  });

}

})

// document.addEventListener("DOMContentLoaded", function() {
//   // Detect mobile devices
//   const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
//   console.log("Is Mobile?", isMobile);

//   if (!isMobile) return; // stop if not mobile

//   // Change this to your actual slick slider container if different
//   const $slider = $('.product-gallery__main');
//   console.log("Slider found?", $slider.length);

//   function autoplayActiveVideo() {
//     console.log("---- autoplayActiveVideo called ----");

//     // Pause all videos first
//     const allVideos = $slider.find("video");
//     console.log("Total videos found:", allVideos.length);
//     allVideos.each(function(i) {
//       console.log("Pausing video", i, this);
//       this.pause();
//     });

//     // Play only the active one
//     const $activeVideo = $slider.find(".slick-current.slick-active video");
//     console.log("Active video found?", $activeVideo.length);

//     if ($activeVideo.length) {
//       const video = $activeVideo.get(0);
//       console.log("Trying to play active video:", video);

//       video.muted = true;
//       video.setAttribute("playsinline", "");
//       video.setAttribute("autoplay", "");
//       video.setAttribute("loop", "");

//       video.play().then(() => {
//         console.log("Video autoplay success ✅");
//       }).catch(err => {
//         console.warn("Autoplay blocked ❌", err);
//       });
//     }
//   }

//   // Run when slick initializes
//   $slider.on('init', function() {
//     console.log("Slick init event fired ✅");
//     autoplayActiveVideo();
//   });

//   // Run on every slide change
//   $slider.on('afterChange', function(event, slick, currentSlide) {
//     console.log("Slick afterChange event fired ✅ | Current slide:", currentSlide);
//     autoplayActiveVideo();
//   });
// });






// document.addEventListener('DOMContentLoaded', function () {
//     const galleryWrapper = document.getElementById('product-lightbox-gallery');

//     galleryWrapper.addEventListener('click', function (e) {
//         const clickedAnchor = e.target.closest('a.gallery-item');
//         if (!clickedAnchor) return;
//         console.log(clickedAnchor)
//         const parentSlide = clickedAnchor.closest('.is-filtered');
//         if (!parentSlide) return; // Only proceed if this is a filtered slide
//         e.preventDefault();
//       e.stopPropagation();

//         // Select only gallery-items inside filtered slides
//         const filteredAnchors = galleryWrapper.querySelectorAll('.is-filtered .gallery-item');
//         console.log(filteredAnchors)
//         // Build the dynamic gallery list
//         const dynamicItems = Array.from(filteredAnchors).map(item => ({
//             src: item.getAttribute('href'),
//             thumb: item.querySelector('img')?.getAttribute('src') || '',
//             poster: item.getAttribute('data-poster') || '',
//             html: item.getAttribute('data-html') || ''
//         }));

//         // Find index of clicked item
//         const clickedIndex = Array.from(filteredAnchors).indexOf(clickedAnchor);
// console.log(clickedIndex)
//         // Initialize LightGallery dynamically
//         const gallery = lightGallery(document.getElementById('product-lightbox-gallery'), {
//                 selector: '.is-filtered .gallery-item',
//                 plugins: [lgZoom, lgVideo, lgThumbnail],
//                 thumbnail: true,
//                 // Disable zoom animation
//                 zoomFromOrigin: false,
//                 showAfterLoad: true,
//                 // Preload images to prevent stretching
//                 preload: 2,
//                 download: false,
//                 licenseKey: '0000-0000-000-0000',
                
//                 // Additional fixes for smooth loading
//                 onAfterOpen: function() {
//                     // Force redraw to fix any rendering issues
//                     const container = document.querySelector('.lg-outer');
//                     if (container) {
//                         container.style.display = 'none';
//                         container.offsetHeight; // Trigger reflow
//                         container.style.display = 'block';
//                     }
//                 },
                
//                 // Pause videos when changing slides
//                 onBeforeSlide: function() {
//                     const videos = document.querySelectorAll('.lg-video-object video');
//                     videos.forEach(video => {
//                         try {
//                             video.pause();
//                             video.currentTime = 0;
//                         } catch(e) {
//                             console.warn('Could not pause video:', e);
//                         }
//                     });
//                 }
//             });
//     });
// });

